module.exports = __webpack_public_path__ + "img/table-edit.02d6d867.svg";